
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service pages
const DijitalBaskiPage = lazy(() => import('../pages/services/dijital-baski/page'));
const TabelaSistemlerPage = lazy(() => import('../pages/services/tabela-sistemleri/page'));
const AracGiydirmePage = lazy(() => import('../pages/services/arac-giydirme/page'));
const CepheKaplamaPage = lazy(() => import('../pages/services/cephe-kaplama/page'));
const CncLazerPage = lazy(() => import('../pages/services/cnc-lazer/page'));
const FolyoBaskiPage = lazy(() => import('../pages/services/folyo-baski/page'));
const IcMekanBaskiPage = lazy(() => import('../pages/services/ic-mekan-baski/page'));
const BaskesPage = lazy(() => import('../pages/services/baskes/page'));
const KuseEtiketPage = lazy(() => import('../pages/services/kuse-etiket/page'));
const PromosyonPage = lazy(() => import('../pages/services/promosyon/page'));

// Portfolio detail pages
const Portfolio1Page = lazy(() => import('../pages/portfolio/1/page'));
const Portfolio2Page = lazy(() => import('../pages/portfolio/2/page'));

// Blog detail pages
const Blog1Page = lazy(() => import('../pages/blog/1/page'));

// Legal pages
const KVKKPage = lazy(() => import('../pages/legal/kvkk/page'));
const GizlilikPage = lazy(() => import('../pages/legal/gizlilik/page'));
const CerezPage = lazy(() => import('../pages/legal/cerez/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />
  },
  {
    path: '/hizmetler/dijital-baski',
    element: <DijitalBaskiPage />
  },
  {
    path: '/hizmetler/tabela-sistemleri',
    element: <TabelaSistemlerPage />
  },
  {
    path: '/hizmetler/arac-giydirme',
    element: <AracGiydirmePage />
  },
  {
    path: '/hizmetler/cephe-kaplama',
    element: <CepheKaplamaPage />
  },
  {
    path: '/hizmetler/cnc-lazer',
    element: <CncLazerPage />
  },
  {
    path: '/hizmetler/folyo-baski',
    element: <FolyoBaskiPage />
  },
  {
    path: '/hizmetler/ic-mekan-baski',
    element: <IcMekanBaskiPage />
  },
  {
    path: '/hizmetler/baskes',
    element: <BaskesPage />
  },
  {
    path: '/hizmetler/kuse-etiket',
    element: <KuseEtiketPage />
  },
  {
    path: '/hizmetler/promosyon',
    element: <PromosyonPage />
  },
  {
    path: '/portfolyo',
    element: <PortfolioPage />
  },
  {
    path: '/portfolyo/1',
    element: <Portfolio1Page />
  },
  {
    path: '/portfolyo/2',
    element: <Portfolio2Page />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/1',
    element: <Blog1Page />
  },
  {
    path: '/iletisim',
    element: <ContactPage />
  },
  {
    path: '/teklif-al',
    element: <QuotePage />
  },
  {
    path: '/sss',
    element: <FAQPage />
  },
  {
    path: '/kvkk',
    element: <KVKKPage />
  },
  {
    path: '/gizlilik',
    element: <GizlilikPage />
  },
  {
    path: '/cerez',
    element: <CerezPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
